import { createContext, useContext, useEffect, useState } from "react";

const LoanApplicationContext = createContext();

export const useLoanApplication = () => useContext(LoanApplicationContext);

export const LoanApplicationProvider = ({ children }) => {
  const [loanApplication, setLoanApplication] = useState(() => {
    const stored = localStorage.getItem("loanApplication");
    return stored ? JSON.parse(stored) : null;
  });

  useEffect(() => {
    if (loanApplication) {
      localStorage.setItem("loanApplication", JSON.stringify(loanApplication));
    } else {
      localStorage.removeItem("loanApplication");
    }
  }, [loanApplication]);

  return (
    <LoanApplicationContext.Provider value={{ loanApplication, setLoanApplication }}>
      {children}
    </LoanApplicationContext.Provider>
  );
};
